module.exports = __webpack_public_path__ + "img/grid.059757de.png";